
import { Component, Vue } from 'vue-property-decorator';
import HeaderTitle from '@/components/HeaderTitle.vue';
import TryNewAtlasBanner from '@/components/TryNewAtlasBanner.vue';
import { ATLAS_FEATURE_LINKS, getFeatureVersion, setFeatureVersion } from '@/config/atlasFeatures';
import GoogleSheetIntroduction from '@/components/GoogleSheetIntroduction.vue';

@Component({
  components: {
    HeaderTitle,
    TryNewAtlasBanner,
    GoogleSheetIntroduction
  },
})
export default class GoogleSpreadsheetIntroductionView extends Vue {
  public async created() {
  }

  private get showTryNewGoogleSheetsBanner(): boolean {
    return getFeatureVersion('googleSheetsReporting') === 'classic';
  }

  private switchGoogleSheetsToAtlas(): void {
    setFeatureVersion('googleSheetsReporting', 'atlas');
    this.$router.push(ATLAS_FEATURE_LINKS.googleSheetsReporting['/google-spreadsheet-introduction']);
  }
}
